module.exports = {"id":"213666","name":"Ruben Loftus-Cheek","rating":"74","photo":"./data/images/photos/4/213666.png","club":{"name":"Crystal Palace","logo":"./data/images/clubs/CrystalPalace.png"},"positions":["MOC","MC","MD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RubenLoftus-Cheek0.json
// module id = 3735
// module chunks = 0